import { Tag, Tooltip } from 'antd';

import styles from './SetupPackTag.module.scss';

export const SETUP_PACK_TAG_LABEL = 'Setup';
export const SETUP_PACK_TAG_TOOLTIP_NIGHT_STAY =
  'This package is not on sale yet. Fill in its price allocation so that Staycation can publish it.';
export const SETUP_PACK_TAG_TOOLTIP_DAYTIME =
  'This package is not on sale yet. Fill in its stock allocation so that Staycation can publish it.';
export const SETUP_PACK_SECTION_TITLE = 'Setup - Pending publication';
export const SETUP_PACK_SECTION_TOOLTIP_NIGHT_STAY =
  'Complete the pricing configuration. Once ready, your Staycation Account Manager will publish it to make it visible to guests.';
export const SETUP_PACK_SECTION_TOOLTIP_DAYTIME =
  'Complete the stock configuration. Once ready, your Staycation Account Manager will publish it to make it visible to guests.';

type SetupPackTagProps = {
  isDaytime: boolean;
};

export const SetupPackTag = ({ isDaytime }: SetupPackTagProps) => (
  <Tooltip
    title={
      isDaytime
        ? SETUP_PACK_TAG_TOOLTIP_DAYTIME
        : SETUP_PACK_TAG_TOOLTIP_NIGHT_STAY
    }
  >
    <Tag className={styles.setupTag}>{SETUP_PACK_TAG_LABEL}</Tag>
  </Tooltip>
);
